import { createFileRoute } from "@tanstack/react-router";
import CrmBordeauxArticle, {
  CRM_BX_DESCRIPTION,
  CRM_BX_PATH,
  CRM_BX_SCHEMA,
  CRM_BX_TITLE,
} from "@/pages/CrmBordeauxArticle";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/implementer-crm-bordeaux-hubspot-salesforce")({
  head: () => {
    const base = pageHead({ path: CRM_BX_PATH, title: CRM_BX_TITLE, description: CRM_BX_DESCRIPTION, enPath: null });
    return {
      ...base,
      meta: [
        ...(base.meta ?? []),
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      scripts: CRM_BX_SCHEMA.map((s) => ({ type: "application/ld+json", children: JSON.stringify(s) })),
    };
  },
  component: CrmBordeauxArticle,
});
